import { render, staticRenderFns } from "./opening-subject-add-or-update.vue?vue&type=template&id=7204e9f8&scoped=true"
import script from "./opening-subject-add-or-update.vue?vue&type=script&lang=js"
export * from "./opening-subject-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./opening-subject-add-or-update.vue?vue&type=style&index=0&id=7204e9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204e9f8",
  null
  
)

export default component.exports